import { tap, finalize } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FileService } from '../../../core/service/file.service';
import { Subscription } from 'rxjs';
import { DwellingInspectionPoint } from '../../../dwelling-inspection/model/dwelling-inspection-point';
import { PriceListService } from '../../service/data/pricelist.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-import-pricelist-form',
    templateUrl: './import-pricelist-form.component.html',
    styleUrls: ['./import-pricelist-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportPriceListFormComponent implements OnDestroy, OnInit {
  constructor(
    private _dataService: PriceListService,
    private _fileService: FileService,
    private _modalService: ActionWindowService,
    _fb: UntypedFormBuilder,
    _fcf: FormControlExFactory
  ) {
    this.form = _fb.group({
      name: _fcf.createMandatory('PRICELIST.PRICELIST', 'Nyckeltal för lägenhetsreparation'),
    });
  }

  private readonly _suscription: Subscription = new Subscription();
  dataContext: DwellingInspectionPoint;

  form: FormGroup;
  selectedItem: string;

  close() {
    this._modalService.close();
  }

  ngOnDestroy() {
    this._suscription.unsubscribe();
  }

  ngOnInit() {}

  busy: boolean = false;

  file: File = null;

  errorMessage: string = '';
  get disabled(): boolean {
    return this.busy || !this.form.valid || !this.file;
  }

  onSubmit() {
    if (this.busy || !this.file || !this.form.valid) return;
    this.busy = true;
    this._suscription.add(
      this._dataService
        .importSabo(this.file, this.form.value.name)
        .pipe(
          tap(() => this._modalService.complete(true)),
          finalize(() => {
            this.busy = false;
          })
        )
        .subscribe()
    );
  }

  onFileChange(files: FileList) {
    if (this.busy || !files.length) return;
    this.errorMessage = '';
    this.file = null;

    let file = files[0];
    if (!this._fileService.isSpreadsheet(file.type)) {
      this.errorMessage = 'ERROR.FORMAT';
      return;
    }

    this.file = file;
  }
}
